import { ObservableFromFetch } from "../ObservableFromFetch"
import EmployeeToMerge from "./OrderResultModel/EmployeeToMerge"


export default function SearchEmployeesToMerge(personId: number, implementationId: number, accountId: number, searchBy: string, searchFor: string) {
    const requestBody: string = JSON.stringify({
        PersonID: personId,
        ImplementationID: implementationId,
        AccountID: accountId,
        SearchBy: searchBy,
        SearchFor: searchFor
    })
    return ObservableFromFetch<EmployeeToMerge[]>("WorkforceRandomTest/SearchEmployeesToMerge", requestBody)
    //const result: EmployeeToMerge[] = []
    //return result
}

export function MergeEmployees(originalPersonId: number, mergePersonId: number, implementationId: number, accountId: number) {
    const requestBody: string = JSON.stringify({
        OriginalPersonID: originalPersonId,
        MergePersonID: mergePersonId,
        ImplementationID: implementationId,
        AccountID: accountId
    })
    return ObservableFromFetch<string>("WorkforceRandomTest/MergeEmployees", requestBody)
}
